<template>
  <div>
    <div class="cover-table">
      <Table
        border
        style="width: 100%;"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <template slot-scope="{ row, index }" slot="action">
          <span class="pointer" @click="handleDeal('projectDetail', row.id)"
            >详情</span
          >
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
import tableTwoMixin from "@/components/tableTwoMixin";
export default {
  mixins: [tableTwoMixin],
  data() {
    return {
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "项目编号",
          key: "projectId",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "工人所属企业统一社会信用代码",
          key: "corpCode",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "工人所属企业名称",
          key: "corpName",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "班组编号",
          key: "teamId",
          minWidth: 140,
          tooltip: true,
          align: "center",
        },
        {
          title: "发放工资的月份",
          key: "payMonth",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "工资单附件",
          key: "attachments",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "工资单详情列表",
          key: "detailList",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "数据来源",
          key: "projectAreaCode",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
      ],
    };
  },
};
</script>
